import * as React from 'react';
import { Radio } from 'semantic-ui-react';


var Checkbox = function (_a) {
    var as = _a.as, checked = _a.checked, className = _a.className, defaultChecked = _a.defaultChecked, disabled = _a.disabled, id = _a.id, label = _a.label, name = _a.name, onChange = _a.onChange, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, tabIndex = _a.tabIndex, value = _a.value, toggle = _a.toggle;
    return (React.createElement(Radio, { type: "checkbox", as: as, checked: checked, className: "pluggy " + (className || ''), defaultChecked: defaultChecked, disabled: disabled, id: id, label: label, name: name, onChange: onChange, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, tabIndex: tabIndex, value: value, toggle: toggle }));
};
export { Checkbox };
